import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { _ as _to_consumable_array } from "@swc/helpers/_/_to_consumable_array";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useState, useEffect, useMemo } from "react";
import { Link, useNavigate } from "react-router-dom";
import Form from "react-bootstrap/Form";
import Select from "react-select";
import Button from "react-bootstrap/Button";
import "react-datepicker/dist/react-datepicker.css";
import DownloadExcel from "utils/DownloadExcel";
import { utils, writeFileXLSX } from "xlsx";
import { defaultOption } from "constants/ui/options";
import { useAppDispatch, useAppSelector } from "../../redux/store/configureStore";
import { getEmpFullNameTHByEmpData, getSupplierFullName, mapMstToOptions, pageInitSize, pageSizeOptions } from "utils/HelperFunction";
import Box from "@mui/material/Box";
import { DataGrid } from "@mui/x-data-grid";
import Grstatus from "fragments/GRStatus";
import { getAllGroupOfSupplier } from "../../redux/handlers/logic/getAllGroupOfSupplier.handler";
import { useGlobalModalContext } from "contexts/GlobalModalContext";
import { useGlobalLoaderContext } from "contexts/GlobalLoaderContext";
import moment from "moment";
import { getAllNewPoSplit } from "../../redux/handlers/logic/getAllNewPoSplit.handler";
import { exportNewPoSplit } from "../../redux/handlers/logic/exportNewPoSplit.handler";
import { getAllNewGr } from "../../redux/handlers/logic/getAllNewGr.handler";
import { getUserInfo } from "../../redux/handlers/auth/getUserInfo.handler";
import { debounce } from "@mui/material";
import { initGrMstStatusCount } from "mocks/grData";
import { initPoSplitStatusCount } from "mocks/poSplitData";
export function GRList() {
    var _useState = _sliced_to_array(useState(0), 2), btntab = _useState[0], setBtntab = _useState[1];
    return /*#__PURE__*/ _jsx("div", {
        children: /*#__PURE__*/ _jsxs("div", {
            className: "pagezoom",
            children: [
                /*#__PURE__*/ _jsx("nav", {
                    "aria-label": "breadcrumb",
                    className: "mt-2 mb-4",
                    children: /*#__PURE__*/ _jsxs("ol", {
                        className: "breadcrumb fs-16 ps-0",
                        children: [
                            /*#__PURE__*/ _jsx("li", {
                                className: "breadcrumb-item ",
                                children: /*#__PURE__*/ _jsx("a", {
                                    href: "#",
                                    className: "tc-7  text-decoration-none",
                                    children: "คลังสินค้า"
                                })
                            }),
                            /*#__PURE__*/ _jsxs("li", {
                                className: "breadcrumb-item active tc-2 ",
                                "aria-current": "page",
                                children: [
                                    " ",
                                    "ใบรับสินค้า",
                                    " "
                                ]
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "fs-24 mb-4 fw-bold tc-2",
                    style: {
                        color: "rgba(76, 78, 100, 0.87)"
                    },
                    children: "ใบสั่งซื้อรอรับสินค้า"
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: "mb-3",
                    children: [
                        /*#__PURE__*/ _jsx(Button, {
                            type: "button",
                            className: "btn-category px-4 ".concat(btntab == 0 ? " active" : "", "  "),
                            onClick: function() {
                                setBtntab(0);
                            },
                            children: "ใบรับสินค้า"
                        }),
                        /*#__PURE__*/ _jsx(Button, {
                            type: "button",
                            className: "btn-category px-4 ".concat(btntab == 1 ? " active" : "", "  "),
                            onClick: function() {
                                setBtntab(1);
                            },
                            children: "ใบสั่งซื้อรอรับสินค้า"
                        })
                    ]
                }),
                btntab == 0 ? /*#__PURE__*/ _jsx(GoodsReceipt, {}) : btntab == 1 ? /*#__PURE__*/ _jsx(PoWaitingProduct, {}) : ""
            ]
        })
    });
}
var PoWaitingProduct = function() {
    var navigate = useNavigate();
    var dispatch = useAppDispatch();
    var _useGlobalModalContext = useGlobalModalContext(), modalObj = _useGlobalModalContext.modalObj, setModalObj = _useGlobalModalContext.setModalObj;
    var _useGlobalLoaderContext = useGlobalLoaderContext(), isloading = _useGlobalLoaderContext.isloading, setIsLoading = _useGlobalLoaderContext.setIsLoading;
    var _useState = _sliced_to_array(useState(""), 2), selectedGroupOfSuplierID = _useState[0], setSelectedGroupOfSuplierID = _useState[1];
    var _useState1 = _sliced_to_array(useState({
        page: 1,
        pageSize: pageInitSize,
        total: 0
    }), 2), pageModel = _useState1[0], setPageModel = _useState1[1];
    var _useState2 = _sliced_to_array(useState(initPoSplitStatusCount), 2), poSplitStatusCount = _useState2[0], setPoSplitStatusCount = _useState2[1];
    var _useState3 = _sliced_to_array(useState(null), 2), filterText = _useState3[0], setFilterText = _useState3[1];
    var _useState4 = _sliced_to_array(useState(null), 2), btnempstatus = _useState4[0], setBtnempstatus = _useState4[1];
    var _useState5 = _sliced_to_array(useState([]), 2), data = _useState5[0], setData = _useState5[1];
    var _useState6 = _sliced_to_array(useState([]), 2), tab = _useState6[0], setTab = _useState6[1];
    var _useState7 = _sliced_to_array(useState([]), 2), tab0 = _useState7[0], setTab0 = _useState7[1];
    var _useState8 = _sliced_to_array(useState([]), 2), tab1 = _useState8[0], setTab1 = _useState8[1];
    var _useState9 = _sliced_to_array(useState(defaultOption), 2), groupOfSupplier = _useState9[0], setGroupOfSupplier = _useState9[1];
    var _useState10 = _sliced_to_array(useState([]), 2), optionsGroupOfSuplier = _useState10[0], setOptionsGroupOfSuplier = _useState10[1];
    var _useState11 = _sliced_to_array(useState(false), 2), isExportPending = _useState11[0], setIsExportPending = _useState11[1];
    var loadAllMsts = function() {
        dispatch(getAllGroupOfSupplier());
    };
    var getData = function(page, limit, searchText, groupSubID, mstNewStatusID) {
        var queryParams = {
            mstNewStatusID: mstNewStatusID,
            isWithReceiveStatus: "true",
            page: page,
            limit: limit,
            searchText: searchText,
            groupSubID: groupSubID
        };
        dispatch(getAllNewPoSplit({
            queryParams: queryParams,
            modalObj: modalObj,
            setModalObj: setModalObj
        }));
    };
    useEffect(function() {
        getData(1, pageModel.pageSize, "", selectedGroupOfSuplierID, btnempstatus || "");
        loadAllMsts();
        dispatch(getUserInfo({
            modalObj: modalObj,
            setModalObj: setModalObj
        }));
    }, []);
    var debouncedSearch = useMemo(function() {
        return debounce(function(searchText, selectedGroupOfSuplierID, btnempstatus) {
            getData(1, pageModel.pageSize, searchText, selectedGroupOfSuplierID, btnempstatus);
        }, 300);
    }, []);
    useEffect(function() {
        if (filterText !== null) {
            debouncedSearch(filterText || "", selectedGroupOfSuplierID, btnempstatus || "");
        }
    }, [
        filterText
    ]);
    useEffect(function() {
        getData(1, pageModel.pageSize, filterText || "", selectedGroupOfSuplierID, btnempstatus || "");
    }, [
        selectedGroupOfSuplierID,
        btnempstatus
    ]);
    // let filteredItems = data.filter((item) => {
    //   const docNumberMatches =
    //     item.doc_number &&
    //     item.doc_number.toLowerCase().includes(filterText.toLowerCase());
    //   const supplierNameMatches =
    //     item.dimNewPurchaseOrder?.dimSupplierInformation &&
    //     getSupplierFullName(item.dimNewPurchaseOrder?.dimSupplierInformation)
    //       .toLowerCase()
    //       .includes(filterText.toLowerCase());
    //   const supplierGroupMatches =
    //     !selectedGroupOfSuplierID ||
    //     (item.dimNewPurchaseOrder?.dimSupplierInformation &&
    //       item.dimNewPurchaseOrder?.dimSupplierInformation.dimGroupOfSupplier &&
    //       selectedGroupOfSuplierID ===
    //       item.dimNewPurchaseOrder?.dimSupplierInformation.dimGroupOfSupplier.id);
    //   return (docNumberMatches || supplierNameMatches) && supplierGroupMatches;
    // });
    var columnsd = [
        {
            field: "doc_number",
            headerName: "เลขที่เอกสาร PO",
            width: 170,
            sortable: false,
            renderCell: function(param) {
                var row = param.row;
                return /*#__PURE__*/ _jsx("a", {
                    className: "tc-9",
                    href: "/purchase/order/edit/".concat(row.dimNewPurchaseOrder.id),
                    target: "_blank",
                    children: row.doc_number
                });
            }
        },
        {
            field: "delivery_date",
            headerName: "วันที่จัดส่ง",
            width: 140,
            sortable: false,
            renderCell: function(param) {
                var row = param.row;
                return /*#__PURE__*/ _jsx("div", {
                    children: moment(row.dimNewPurchaseOrder.delivery_date).format("DD/MM/YYYY")
                });
            }
        },
        {
            field: "dimSupplierInformation",
            headerName: "ชื่อผู้จำหน่าย",
            width: 250,
            flex: 1,
            sortable: false,
            renderCell: function(param) /*#__PURE__*/ {
                var row = param.row;
                var _row_dimNewPurchaseOrder_dimSupplierInformation_company_branch_name;
                return _jsx("div", {
                    children: row.dimNewPurchaseOrder.dimSupplierInformation ? /*#__PURE__*/ _jsxs(_Fragment, {
                        children: [
                            getSupplierFullName(row.dimNewPurchaseOrder.dimSupplierInformation),
                            /*#__PURE__*/ _jsx("br", {}),
                            "(",
                            (_row_dimNewPurchaseOrder_dimSupplierInformation_company_branch_name = row.dimNewPurchaseOrder.dimSupplierInformation.company_branch_name) !== null && _row_dimNewPurchaseOrder_dimSupplierInformation_company_branch_name !== void 0 ? _row_dimNewPurchaseOrder_dimSupplierInformation_company_branch_name : "-",
                            ")"
                        ]
                    }) : "-"
                });
            }
        },
        {
            field: "dim_warehouse_id",
            headerName: "คลังที่รับสินค้า",
            width: 200,
            flex: 1,
            sortable: false,
            renderCell: function(param) {
                var row = param.row;
                return /*#__PURE__*/ _jsx("div", {
                    children: row.dimWarehouse.name
                });
            }
        },
        {
            field: "sum_item_quantity",
            headerName: "จำนวนสินค้า",
            width: 160,
            align: "center",
            headerAlign: "center",
            sortable: false,
            renderCell: function(param) {
                var row = param.row;
                return /*#__PURE__*/ _jsx("div", {
                    children: row.sum_item_quantity
                });
            }
        },
        {
            field: "total_received_quantity",
            headerName: "จำนวนสินค้าที่รับแล้ว",
            sortable: false,
            align: "center",
            headerAlign: "center",
            width: 200,
            renderCell: function(param) {
                var row = param.row;
                return /*#__PURE__*/ _jsx("div", {
                    children: row.total_received_quantity
                });
            }
        },
        {
            headerName: "สถานะ",
            field: "dim_mst_new_status_id",
            headerAlign: "center",
            align: "center",
            width: 210,
            sortable: false,
            renderCell: function(param) {
                var row = param.row;
                var _row_dimMstNewStatus, _row_dimMstNewStatus1;
                var statusID = (_row_dimMstNewStatus = row.dimMstNewStatus) === null || _row_dimMstNewStatus === void 0 ? void 0 : _row_dimMstNewStatus.id;
                var statusName = (_row_dimMstNewStatus1 = row.dimMstNewStatus) === null || _row_dimMstNewStatus1 === void 0 ? void 0 : _row_dimMstNewStatus1.name;
                var finanStatusID = row.dim_mst_financial_status_id;
                return /*#__PURE__*/ _jsx(Grstatus, {
                    statusID: statusID,
                    statusName: statusName,
                    finanStatusID: finanStatusID
                });
            }
        },
        {
            field: "id",
            headerName: "จัดการ",
            sortable: false,
            width: 160,
            renderCell: function(param) {
                var row = param.row;
                return /*#__PURE__*/ _jsx(Button, {
                    href: "/goods-receipt/create/".concat(row.id),
                    type: "button",
                    className: "text-white bg-[#565DFF] px-3 py-2",
                    onClick: function() {
                    // setBtnempstatus(0);
                    // setData(tab);
                    },
                    children: "รับสินค้า"
                });
            }
        }
    ];
    var getAllGroupOfSupplierReducer = useAppSelector(function(state) {
        return state.getAllGroupOfSupplierReducer;
    });
    var getAllNewPoSplitReducer = useAppSelector(function(state) {
        return state.getAllNewPoSplitReducer;
    });
    var exportNewPoSplitReducer = useAppSelector(function(state) {
        return state.exportNewPoSplitReducer;
    });
    var getUserInfoReducer = useAppSelector(function(state) {
        return state.getUserInfoReducer;
    });
    useEffect(function() {
        setIsLoading(getAllGroupOfSupplierReducer.isFetching);
        if (getAllGroupOfSupplierReducer.data) {
            var options = mapMstToOptions(getAllGroupOfSupplierReducer.data.data);
            setOptionsGroupOfSuplier([
                defaultOption
            ].concat(_to_consumable_array(options)));
        }
    }, [
        getAllGroupOfSupplierReducer
    ]);
    useEffect(function() {
        setIsLoading(getAllNewPoSplitReducer.isFetching);
        if (getAllNewPoSplitReducer.data) {
            var result = getAllNewPoSplitReducer.data.data.data;
            var meta = getAllNewPoSplitReducer.data.data.meta;
            var poSplitStatusCount = getAllNewPoSplitReducer.data.data.poSplitStatusCount;
            setData(result);
            setPageModel({
                page: meta.page,
                pageSize: meta.limit,
                total: meta.total
            });
            setTab(result);
            setPoSplitStatusCount(poSplitStatusCount);
        // const status1 = result.filter((item) => item.dim_mst_new_status_id === 4);
        // const status2 = result.filter((item) => item.dim_mst_new_status_id === 5);
        // setTab0(status1);
        // setTab1(status2);
        }
    }, [
        getAllNewPoSplitReducer
    ]);
    useEffect(function() {
        if (!isExportPending) return;
        if (exportNewPoSplitReducer.isFetching) return;
        if (exportNewPoSplitReducer.data) {
            var _exportNewPoSplitReducer_data_data, _getUserInfoReducer_data;
            var _exportNewPoSplitReducer_data_data_data;
            var exportData = (_exportNewPoSplitReducer_data_data_data = (_exportNewPoSplitReducer_data_data = exportNewPoSplitReducer.data.data) === null || _exportNewPoSplitReducer_data_data === void 0 ? void 0 : _exportNewPoSplitReducer_data_data.data) !== null && _exportNewPoSplitReducer_data_data_data !== void 0 ? _exportNewPoSplitReducer_data_data_data : [];
            var rows = [];
            exportData.forEach(function(row) {
                var _row_dimNewPurchaseOrder, _row_dimNewPurchaseOrder1, _row_dimWarehouse;
                var docNumber = row.doc_number;
                var deliveryDate = ((_row_dimNewPurchaseOrder = row.dimNewPurchaseOrder) === null || _row_dimNewPurchaseOrder === void 0 ? void 0 : _row_dimNewPurchaseOrder.delivery_date) ? moment(row.dimNewPurchaseOrder.delivery_date).format("DD/MM/YYYY") : "-";
                var supplierInfo = (_row_dimNewPurchaseOrder1 = row.dimNewPurchaseOrder) === null || _row_dimNewPurchaseOrder1 === void 0 ? void 0 : _row_dimNewPurchaseOrder1.dimSupplierInformation;
                var _supplierInfo_code;
                var supplierCode = (_supplierInfo_code = supplierInfo === null || supplierInfo === void 0 ? void 0 : supplierInfo.code) !== null && _supplierInfo_code !== void 0 ? _supplierInfo_code : "-";
                var _supplierInfo_company_branch_name;
                var supplierName = supplierInfo ? "".concat(getSupplierFullName(supplierInfo), " (").concat((_supplierInfo_company_branch_name = supplierInfo.company_branch_name) !== null && _supplierInfo_company_branch_name !== void 0 ? _supplierInfo_company_branch_name : "ไม่ระบุ", ")") : "-";
                var _row_dimWarehouse_name;
                var warehouseName = (_row_dimWarehouse_name = (_row_dimWarehouse = row.dimWarehouse) === null || _row_dimWarehouse === void 0 ? void 0 : _row_dimWarehouse.name) !== null && _row_dimWarehouse_name !== void 0 ? _row_dimWarehouse_name : "-";
                var _row_dimNewPoSplitItem;
                var items = ((_row_dimNewPoSplitItem = row.dimNewPoSplitItem) !== null && _row_dimNewPoSplitItem !== void 0 ? _row_dimNewPoSplitItem : []).filter(function(item) {
                    return item.quantity !== item.total_received_quantity;
                });
                if (items.length === 0) {
                    return;
                }
                items.forEach(function(item) {
                    var _item_dimProductPrice_dimProduct, _item_dimProductPrice, _item_dimProductPrice1, _item_dimProductPrice_dimProduct1, _item_dimProductPrice2, _item_dimMasterUnit;
                    var rawRatio = item.ratio_unit != null ? Number(item.ratio_unit) : null;
                    var ratioNum = rawRatio || 1;
                    var ratioUnit = rawRatio != null ? "1x".concat(rawRatio) : "";
                    var _item_quantity;
                    var ordered = (_item_quantity = item.quantity) !== null && _item_quantity !== void 0 ? _item_quantity : 0;
                    var _item_total_received_quantity;
                    var received = (_item_total_received_quantity = item.total_received_quantity) !== null && _item_total_received_quantity !== void 0 ? _item_total_received_quantity : 0;
                    var remaining = ordered - received;
                    var _item_dimProductPrice_dimProduct_sku, _item_dimProductPrice_barcode, _item_dimProductPrice_dimProduct_name_th, _item_dimMasterUnit_name;
                    rows.push({
                        "เลขที่เอกสาร PO": docNumber,
                        "วันที่จัดส่ง": deliveryDate,
                        "รหัส SUP": supplierCode,
                        "ผู้จำหน่าย": supplierName,
                        "คลังที่รับสินค้า": warehouseName,
                        "SKU": (_item_dimProductPrice_dimProduct_sku = (_item_dimProductPrice = item.dimProductPrice) === null || _item_dimProductPrice === void 0 ? void 0 : (_item_dimProductPrice_dimProduct = _item_dimProductPrice.dimProduct) === null || _item_dimProductPrice_dimProduct === void 0 ? void 0 : _item_dimProductPrice_dimProduct.sku) !== null && _item_dimProductPrice_dimProduct_sku !== void 0 ? _item_dimProductPrice_dimProduct_sku : "",
                        "Barcode": (_item_dimProductPrice_barcode = (_item_dimProductPrice1 = item.dimProductPrice) === null || _item_dimProductPrice1 === void 0 ? void 0 : _item_dimProductPrice1.barcode) !== null && _item_dimProductPrice_barcode !== void 0 ? _item_dimProductPrice_barcode : "",
                        "ชื่อสินค้า": (_item_dimProductPrice_dimProduct_name_th = (_item_dimProductPrice2 = item.dimProductPrice) === null || _item_dimProductPrice2 === void 0 ? void 0 : (_item_dimProductPrice_dimProduct1 = _item_dimProductPrice2.dimProduct) === null || _item_dimProductPrice_dimProduct1 === void 0 ? void 0 : _item_dimProductPrice_dimProduct1.name_th) !== null && _item_dimProductPrice_dimProduct_name_th !== void 0 ? _item_dimProductPrice_dimProduct_name_th : "",
                        "จำนวนสินค้า": remaining,
                        "หน่วย": (_item_dimMasterUnit_name = (_item_dimMasterUnit = item.dimMasterUnit) === null || _item_dimMasterUnit === void 0 ? void 0 : _item_dimMasterUnit.name) !== null && _item_dimMasterUnit_name !== void 0 ? _item_dimMasterUnit_name : "-",
                        "อัตตราส่วน": ratioUnit,
                        "จำนวนสินค้า UMS": remaining * ratioNum
                    });
                });
            });
            var colHeaders = [
                "เลขที่เอกสาร PO",
                "วันที่จัดส่ง",
                "รหัส SUP",
                "ผู้จำหน่าย",
                "คลังที่รับสินค้า",
                "SKU",
                "Barcode",
                "ชื่อสินค้า",
                "จำนวนสินค้า",
                "หน่วย",
                "อัตตราส่วน",
                "จำนวนสินค้า UMS"
            ];
            var userData = (_getUserInfoReducer_data = getUserInfoReducer.data) === null || _getUserInfoReducer_data === void 0 ? void 0 : _getUserInfoReducer_data.data;
            var userName = getEmpFullNameTHByEmpData(userData === null || userData === void 0 ? void 0 : userData.dimNewAlldernowEmp);
            var now = moment().format("DD/MM/YYYY - hh:mm A");
            var aoa = [
                [
                    "รายงานรอรับสินค้าตามใบสั่งซื้อแยกรายการ"
                ],
                [
                    "จำนวนรายการ",
                    "".concat(rows.length, " รายการ")
                ],
                [
                    "ผู้จัดทำ",
                    userName,
                    null,
                    null,
                    null,
                    "เวลาดึงข้อมูล",
                    now
                ],
                [],
                colHeaders
            ].concat(_to_consumable_array(rows.map(function(r) {
                return colHeaders.map(function(col) {
                    return r[col];
                });
            })));
            var ws = utils.aoa_to_sheet(aoa);
            var wb = utils.book_new();
            utils.book_append_sheet(wb, ws, "ใบสั่งซื้อรอรับสินค้า");
            writeFileXLSX(wb, "ใบสั่งซื้อรอรับสินค้า.xlsx");
            setIsExportPending(false);
        }
    }, [
        exportNewPoSplitReducer,
        isExportPending
    ]);
    return /*#__PURE__*/ _jsxs("div", {
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "mb-3",
                children: [
                    /*#__PURE__*/ _jsxs(Button, {
                        type: "button",
                        className: "btn-category px-4 ".concat(btnempstatus == null ? " active" : "", " "),
                        onClick: function() {
                            setBtnempstatus(null);
                            setData(tab);
                        },
                        children: [
                            "ทั้งหมด",
                            " "
                        ]
                    }),
                    /*#__PURE__*/ _jsxs(Button, {
                        type: "button",
                        className: "btn-category px-4 ".concat(btnempstatus == 4 ? " active" : "", "  "),
                        onClick: function() {
                            setBtnempstatus(4);
                        // setData(tab0);
                        },
                        children: [
                            "รอรับสินค้า (",
                            poSplitStatusCount["4"],
                            ")"
                        ]
                    }),
                    /*#__PURE__*/ _jsxs(Button, {
                        type: "button",
                        className: "btn-category px-4 ".concat(btnempstatus == 5 ? " active" : "", "  "),
                        onClick: function() {
                            setBtnempstatus(5);
                        // setData(tab1);
                        },
                        children: [
                            "รับสินค้าบางส่วน (",
                            poSplitStatusCount["5"],
                            ")"
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "card card-st-2 ",
                children: /*#__PURE__*/ _jsxs("div", {
                    className: "card-body px-0 pt-4 pb-0",
                    children: [
                        /*#__PURE__*/ _jsxs("div", {
                            className: "d-flex align-items-center px-4 mb-3 flex-wrap",
                            children: [
                                /*#__PURE__*/ _jsx("div", {
                                    className: "me-4",
                                    style: {
                                        marginBottom: "12px"
                                    },
                                    children: /*#__PURE__*/ _jsx(DownloadExcel, {
                                        data: data,
                                        filename: "ใบสั่งซื้อ PO"
                                    })
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: "me-4",
                                    style: {
                                        marginBottom: "12px"
                                    },
                                    children: /*#__PURE__*/ _jsx("button", {
                                        className: "btn btn-st-7 px-4",
                                        disabled: exportNewPoSplitReducer.isFetching,
                                        onClick: function() {
                                            var queryParams = {
                                                // mstNewStatusID: btnempstatus || '',
                                                isWithReceiveStatus: "true",
                                                searchText: filterText || "",
                                                groupSubID: selectedGroupOfSuplierID || ""
                                            };
                                            setIsExportPending(true);
                                            dispatch(exportNewPoSplit({
                                                queryParams: queryParams,
                                                modalObj: modalObj,
                                                setModalObj: setModalObj
                                            }));
                                        },
                                        children: exportNewPoSplitReducer.isFetching ? "กำลังโหลด..." : "Export รายการใบสั่งซื้อรอรับสินค้า"
                                    })
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: "mb-2 me-auto",
                                    style: {
                                        width: "220px"
                                    },
                                    children: /*#__PURE__*/ _jsxs(Form.Group, {
                                        className: "form-st-3 sm pb-1",
                                        children: [
                                            /*#__PURE__*/ _jsx(Form.Label, {
                                                className: "mb-1",
                                                children: "กลุ่มผู้จัดจำหน่าย"
                                            }),
                                            /*#__PURE__*/ _jsx(Select, {
                                                as: "select",
                                                name: "",
                                                onChange: function(e) {
                                                    setSelectedGroupOfSuplierID(e.value);
                                                    setGroupOfSupplier(e);
                                                },
                                                className: "w-100 select-st-1",
                                                options: optionsGroupOfSuplier,
                                                placeholder: "",
                                                value: groupOfSupplier
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: "me-3 mb-2",
                                    children: /*#__PURE__*/ _jsx("input", {
                                        type: "text",
                                        className: "form-control form-st-4",
                                        placeholder: "ค้นหาเลขที่,ชื่อผู้จำหน่าย",
                                        onKeyUp: function(e) {
                                            return setFilterText(e.target.value);
                                        }
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsx(Box, {
                            sx: {
                                height: "782px",
                                width: "100%"
                            },
                            children: /*#__PURE__*/ _jsx(DataGrid, {
                                getRowId: function(row) {
                                    return row.id;
                                },
                                getRowHeight: function() {
                                    return "auto";
                                },
                                loading: getAllNewPoSplitReducer.isFetching,
                                rows: data,
                                pagination: true,
                                paginationMode: "server",
                                paginationModel: {
                                    page: pageModel.page - 1,
                                    pageSize: pageModel.pageSize
                                },
                                onPaginationModelChange: function(newPagination) {
                                    setPageModel(function(prev) {
                                        return _object_spread_props(_object_spread({}, prev), {
                                            page: newPagination.page + 1,
                                            pageSize: newPagination.pageSize
                                        });
                                    });
                                    getData(newPagination.page + 1, newPagination.pageSize, filterText || "", selectedGroupOfSuplierID, btnempstatus || "");
                                },
                                rowsPerPage: pageModel.page,
                                rowCount: pageModel.total,
                                columns: columnsd,
                                pageSizeOptions: pageSizeOptions,
                                checkboxSelection: true,
                                disableRowSelectionOnClick: true,
                                slotProps: {
                                    pagination: {
                                        labelRowsPerPage: "จำนวนรายการต่อหน้า"
                                    }
                                },
                                sx: {
                                    fontFamily: "Sarabun",
                                    fontSize: "18px",
                                    ".MuiDataGrid-columnHeaderTitle": {
                                        fontFamily: "Sarabun",
                                        fontSize: "18px"
                                    }
                                }
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "py-4"
            })
        ]
    });
};
var result = [
    {
        "id": 1,
        "doc_number": "PO-2410000001-1",
        "delivery_date": "02/11/2023",
        "dimSupplierInformation": {
            "id": 4,
            "dim_mst_business_type_id": 2,
            "dim_mst_business_category_id": 1,
            "dim_group_of_supplier_id": 4,
            "dim_mst_prefix_id": null,
            "code": null,
            "credit_days": 0,
            "img_path": "media/dim-supplier-information/1723198186749-976816301.jpg",
            "tax_identification_number": "105600076669",
            "first_name": null,
            "last_name": null,
            "initials": "EGC",
            "dim_mst_company_prefix_id": 2,
            "company_name": "อีเจนซี่ เอเชีย",
            "company_branch_code": "00000",
            "company_branch_name": "สำนักงานใหญ่",
            "company_address": "354 ถ.พหลโยธิน",
            "company_sub_district": "เสนานิคม",
            "company_district": "จตุจักร",
            "company_province": "กรุงเทพมหานคร",
            "company_postal_code": "10900",
            "company_phone_number": "0888964222",
            "company_mobile_phone_number": "0888964222",
            "company_email": "a@mail.com",
            "company_website": "egencyasia.com",
            "doc_delivery_address": "354 ถ.พหลโยธิน",
            "doc_delivery_sub_district": "เสนานิคม",
            "doc_delivery_district": "จตุจักร",
            "doc_delivery_province": "กรุงเทพมหานคร",
            "doc_delivery_postal_code": "10900",
            "doc_delivery_phone_number": "0888964222",
            "doc_delivery_mobile_phone_number": "0888964222",
            "doc_delivery_email": "a@mail.com",
            "main_contact_first_name": null,
            "main_contact_last_name": null,
            "main_contact_nick_name": null,
            "main_contact_email": null,
            "main_contact_phone_number": null,
            "main_contact_mobile_phone_number": null,
            "main_contact_position": null,
            "alternate_contact_first_name": null,
            "alternate_contact_last_name": null,
            "alternate_contact_nick_name": null,
            "alternate_contact_email": null,
            "alternate_contact_phone_number": null,
            "alternate_contact_mobile_phone_number": null,
            "alternate_contact_position": null,
            "dim_mst_price_category_id": 2,
            "dim_mst_payment_term_id": null,
            "dim_mst_payment_method_id": null,
            "dim_mst_payment_type_id": 2,
            "is_credit_limit": null,
            "received_credit_limit": null,
            "line_token": null,
            "is_active": true,
            "created_by": 1,
            "created_at": "2024-08-09T10:09:47.000Z",
            "updated_at": "2024-08-29T04:12:09.000Z",
            "dimMstCompanyPrefix": {
                "id": 2,
                "name": "บริษัทจำกัด",
                "prefix": "บริษัท",
                "suffix": "จำกัด",
                "is_active": true,
                "created_at": "2024-08-09T12:55:54.000Z",
                "updated_at": "2024-08-16T01:28:13.000Z"
            },
            "dimGroupOfSupplier": {
                "id": 4,
                "code": "FZ01",
                "name": "สินค้าแช่เเข็ง",
                "desc": "สินค้าแช่เเข็ง",
                "is_active": true,
                "created_at": "2024-08-09T10:07:43.000Z",
                "updated_at": "2024-08-09T10:07:43.000Z",
                "deleted_at": null
            }
        },
        "dim_warehouse_id": 4,
        "dim_warehouse_name": "002-คลังสำนักงานใหญ่",
        "sum_item_quantity": 181,
        "item_quantity_receive": 0,
        "statusID": 1
    },
    {
        "id": 5,
        "doc_number": "PO-2410000001-1",
        "delivery_date": "02/11/2023",
        "dimSupplierInformation": {
            "id": 4,
            "dim_mst_business_type_id": 2,
            "dim_mst_business_category_id": 1,
            "dim_group_of_supplier_id": 4,
            "dim_mst_prefix_id": null,
            "code": null,
            "credit_days": 0,
            "img_path": "media/dim-supplier-information/1723198186749-976816301.jpg",
            "tax_identification_number": "105600076669",
            "first_name": null,
            "last_name": null,
            "initials": "EGC",
            "dim_mst_company_prefix_id": 2,
            "company_name": "อีเจนซี่ เอเชีย",
            "company_branch_code": "00000",
            "company_branch_name": "สำนักงานใหญ่",
            "company_address": "354 ถ.พหลโยธิน",
            "company_sub_district": "เสนานิคม",
            "company_district": "จตุจักร",
            "company_province": "กรุงเทพมหานคร",
            "company_postal_code": "10900",
            "company_phone_number": "0888964222",
            "company_mobile_phone_number": "0888964222",
            "company_email": "a@mail.com",
            "company_website": "egencyasia.com",
            "doc_delivery_address": "354 ถ.พหลโยธิน",
            "doc_delivery_sub_district": "เสนานิคม",
            "doc_delivery_district": "จตุจักร",
            "doc_delivery_province": "กรุงเทพมหานคร",
            "doc_delivery_postal_code": "10900",
            "doc_delivery_phone_number": "0888964222",
            "doc_delivery_mobile_phone_number": "0888964222",
            "doc_delivery_email": "a@mail.com",
            "main_contact_first_name": null,
            "main_contact_last_name": null,
            "main_contact_nick_name": null,
            "main_contact_email": null,
            "main_contact_phone_number": null,
            "main_contact_mobile_phone_number": null,
            "main_contact_position": null,
            "alternate_contact_first_name": null,
            "alternate_contact_last_name": null,
            "alternate_contact_nick_name": null,
            "alternate_contact_email": null,
            "alternate_contact_phone_number": null,
            "alternate_contact_mobile_phone_number": null,
            "alternate_contact_position": null,
            "dim_mst_price_category_id": 2,
            "dim_mst_payment_term_id": null,
            "dim_mst_payment_method_id": null,
            "dim_mst_payment_type_id": 2,
            "is_credit_limit": null,
            "received_credit_limit": null,
            "line_token": null,
            "is_active": true,
            "created_by": 1,
            "created_at": "2024-08-09T10:09:47.000Z",
            "updated_at": "2024-08-29T04:12:09.000Z",
            "dimMstCompanyPrefix": {
                "id": 2,
                "name": "บริษัทจำกัด",
                "prefix": "บริษัท",
                "suffix": "จำกัด",
                "is_active": true,
                "created_at": "2024-08-09T12:55:54.000Z",
                "updated_at": "2024-08-16T01:28:13.000Z"
            },
            "dimGroupOfSupplier": {
                "id": 4,
                "code": "FZ01",
                "name": "สินค้าแช่เเข็ง",
                "desc": "สินค้าแช่เเข็ง",
                "is_active": true,
                "created_at": "2024-08-09T10:07:43.000Z",
                "updated_at": "2024-08-09T10:07:43.000Z",
                "deleted_at": null
            }
        },
        "dim_warehouse_id": 4,
        "dim_warehouse_name": "002-คลังสำนักงานใหญ่",
        "sum_item_quantity": 181,
        "item_quantity_receive": 0,
        "statusID": 1
    },
    {
        "id": 2,
        "doc_number": "PO-2410000001-1",
        "delivery_date": "02/11/2023",
        "dimSupplierInformation": {
            "id": 4,
            "dim_mst_business_type_id": 2,
            "dim_mst_business_category_id": 1,
            "dim_group_of_supplier_id": 4,
            "dim_mst_prefix_id": null,
            "code": null,
            "credit_days": 0,
            "img_path": "media/dim-supplier-information/1723198186749-976816301.jpg",
            "tax_identification_number": "105600076669",
            "first_name": null,
            "last_name": null,
            "initials": "EGC",
            "dim_mst_company_prefix_id": 2,
            "company_name": "อีเจนซี่ เอเชีย",
            "company_branch_code": "00000",
            "company_branch_name": "สำนักงานใหญ่",
            "company_address": "354 ถ.พหลโยธิน",
            "company_sub_district": "เสนานิคม",
            "company_district": "จตุจักร",
            "company_province": "กรุงเทพมหานคร",
            "company_postal_code": "10900",
            "company_phone_number": "0888964222",
            "company_mobile_phone_number": "0888964222",
            "company_email": "a@mail.com",
            "company_website": "egencyasia.com",
            "doc_delivery_address": "354 ถ.พหลโยธิน",
            "doc_delivery_sub_district": "เสนานิคม",
            "doc_delivery_district": "จตุจักร",
            "doc_delivery_province": "กรุงเทพมหานคร",
            "doc_delivery_postal_code": "10900",
            "doc_delivery_phone_number": "0888964222",
            "doc_delivery_mobile_phone_number": "0888964222",
            "doc_delivery_email": "a@mail.com",
            "main_contact_first_name": null,
            "main_contact_last_name": null,
            "main_contact_nick_name": null,
            "main_contact_email": null,
            "main_contact_phone_number": null,
            "main_contact_mobile_phone_number": null,
            "main_contact_position": null,
            "alternate_contact_first_name": null,
            "alternate_contact_last_name": null,
            "alternate_contact_nick_name": null,
            "alternate_contact_email": null,
            "alternate_contact_phone_number": null,
            "alternate_contact_mobile_phone_number": null,
            "alternate_contact_position": null,
            "dim_mst_price_category_id": 2,
            "dim_mst_payment_term_id": null,
            "dim_mst_payment_method_id": null,
            "dim_mst_payment_type_id": 2,
            "is_credit_limit": null,
            "received_credit_limit": null,
            "line_token": null,
            "is_active": true,
            "created_by": 1,
            "created_at": "2024-08-09T10:09:47.000Z",
            "updated_at": "2024-08-29T04:12:09.000Z",
            "dimMstCompanyPrefix": {
                "id": 2,
                "name": "บริษัทจำกัด",
                "prefix": "บริษัท",
                "suffix": "จำกัด",
                "is_active": true,
                "created_at": "2024-08-09T12:55:54.000Z",
                "updated_at": "2024-08-16T01:28:13.000Z"
            },
            "dimGroupOfSupplier": {
                "id": 4,
                "code": "FZ01",
                "name": "สินค้าแช่เเข็ง",
                "desc": "สินค้าแช่เเข็ง",
                "is_active": true,
                "created_at": "2024-08-09T10:07:43.000Z",
                "updated_at": "2024-08-09T10:07:43.000Z",
                "deleted_at": null
            }
        },
        "dim_warehouse_id": 4,
        "dim_warehouse_name": "002-คลังสำนักงานใหญ่",
        "sum_item_quantity": 181,
        "item_quantity_receive": 0,
        "statusID": 2
    }
];
var GoodsReceipt = function() {
    var navigate = useNavigate();
    var dispatch = useAppDispatch();
    var _useGlobalModalContext = useGlobalModalContext(), modalObj = _useGlobalModalContext.modalObj, setModalObj = _useGlobalModalContext.setModalObj;
    var _useGlobalLoaderContext = useGlobalLoaderContext(), isloading = _useGlobalLoaderContext.isloading, setIsLoading = _useGlobalLoaderContext.setIsLoading;
    var _useState = _sliced_to_array(useState({
        page: 1,
        pageSize: pageInitSize,
        total: 0
    }), 2), pageModel = _useState[0], setPageModel = _useState[1];
    var _useState1 = _sliced_to_array(useState(initGrMstStatusCount), 2), grStatusCount = _useState1[0], setGrStatusCount = _useState1[1];
    var _useState2 = _sliced_to_array(useState(""), 2), selectedGroupOfSuplierID = _useState2[0], setSelectedGroupOfSuplierID = _useState2[1];
    var _useState3 = _sliced_to_array(useState(null), 2), btnempstatus = _useState3[0], setBtnempstatus = _useState3[1];
    var _useState4 = _sliced_to_array(useState([]), 2), data = _useState4[0], setData = _useState4[1];
    var _useState5 = _sliced_to_array(useState([]), 2), tab = _useState5[0], setTab = _useState5[1];
    var _useState6 = _sliced_to_array(useState([]), 2), tab0 = _useState6[0], setTab0 = _useState6[1];
    var _useState7 = _sliced_to_array(useState([]), 2), tab1 = _useState7[0], setTab1 = _useState7[1];
    var _useState8 = _sliced_to_array(useState([]), 2), tab2 = _useState8[0], setTab2 = _useState8[1];
    var _useState9 = _sliced_to_array(useState([]), 2), tab3 = _useState9[0], setTab3 = _useState9[1];
    var _useState10 = _sliced_to_array(useState(defaultOption), 2), groupOfSupplier = _useState10[0], setGroupOfSupplier = _useState10[1];
    var _useState11 = _sliced_to_array(useState([]), 2), optionsGroupOfSuplier = _useState11[0], setOptionsGroupOfSuplier = _useState11[1];
    var _useState12 = _sliced_to_array(useState(null), 2), filterText = _useState12[0], setFilterText = _useState12[1];
    var debouncedSearch = useMemo(function() {
        return debounce(function(searchText, selectedGroupOfSuplierID, btnempstatus) {
            getData(1, pageModel.pageSize, searchText, selectedGroupOfSuplierID, btnempstatus);
        }, 300);
    }, []);
    useEffect(function() {
        if (filterText !== null) {
            debouncedSearch(filterText || "", selectedGroupOfSuplierID, btnempstatus || "");
        }
    }, [
        filterText
    ]);
    useEffect(function() {
        getData(1, pageModel.pageSize, filterText || "", selectedGroupOfSuplierID, btnempstatus || "");
    }, [
        selectedGroupOfSuplierID,
        btnempstatus
    ]);
    var columnsd = [
        {
            field: "doc_number",
            headerName: "เลขที่ใบรับสินค้า",
            width: 170,
            sortable: false,
            renderCell: function(param) {
                var row = param.row;
                return /*#__PURE__*/ _jsx("a", {
                    className: "tc-9 text-[#565DFF] font-medium",
                    href: "/goods-receipt/edit/".concat(row.id),
                    target: "_blank",
                    children: row.doc_number
                });
            }
        },
        {
            field: "doc_receive_date",
            headerName: "วันที่รับสินค้า",
            width: 140,
            sortable: false,
            renderCell: function(param) {
                var row = param.row;
                return /*#__PURE__*/ _jsx("div", {
                    children: moment(row.doc_receive_date).format("DD/MM/YYYY")
                });
            }
        },
        {
            field: "doc_ref",
            headerName: "เลขที่อ้างอิง",
            width: 180,
            sortable: false,
            renderCell: function(param) {
                var row = param.row;
                return /*#__PURE__*/ _jsx("div", {
                    children: row.po_split_refer
                });
            }
        },
        {
            field: "dimSupplierInformation",
            headerName: "ชื่อผู้จำหน่าย",
            width: 250,
            flex: 1,
            sortable: false,
            renderCell: function(param) {
                var row = param.row;
                return /*#__PURE__*/ _jsx("div", {
                    children: row.dimSupplierInformation ? /*#__PURE__*/ _jsxs(_Fragment, {
                        children: [
                            getSupplierFullName(row.dimSupplierInformation),
                            row.dimSupplierInformation.company_branch_name && /*#__PURE__*/ _jsxs(_Fragment, {
                                children: [
                                    /*#__PURE__*/ _jsx("br", {}),
                                    "(",
                                    row.dimSupplierInformation.company_branch_name || "-",
                                    ")"
                                ]
                            })
                        ]
                    }) : "-"
                });
            }
        },
        {
            field: "dim_warehouse_id",
            headerName: "คลังที่รับสินค้า",
            width: 200,
            sortable: false,
            renderCell: function(param) {
                var row = param.row;
                return /*#__PURE__*/ _jsx("div", {
                    children: row.dimWarehouse.name
                });
            }
        },
        {
            field: "total_receive_quantity",
            headerName: "จำนวนสินค้า",
            width: 160,
            align: "center",
            headerAlign: "center",
            sortable: false,
            renderCell: function(param) {
                var row = param.row;
                return /*#__PURE__*/ _jsx("div", {
                    children: row.total_receive_quantity
                });
            }
        },
        {
            field: "dim_new_alldernow_emp_id",
            headerName: "ผู้รับสินค้า",
            sortable: false,
            align: "center",
            headerAlign: "center",
            width: 220,
            renderCell: function(param) {
                var row = param.row;
                return /*#__PURE__*/ _jsx("div", {
                    children: getEmpFullNameTHByEmpData(row.createdNewGrEmp)
                });
            }
        },
        {
            headerName: "สถานะ",
            field: "dim_mst_new_status_id",
            headerAlign: "center",
            align: "center",
            width: 210,
            sortable: false,
            renderCell: function(param) {
                var row = param.row;
                var _row_dimMstNewStatus, _row_dimMstNewStatus1;
                var statusID = (_row_dimMstNewStatus = row.dimMstNewStatus) === null || _row_dimMstNewStatus === void 0 ? void 0 : _row_dimMstNewStatus.id;
                var statusName = (_row_dimMstNewStatus1 = row.dimMstNewStatus) === null || _row_dimMstNewStatus1 === void 0 ? void 0 : _row_dimMstNewStatus1.name;
                var finanStatusID = row.dim_mst_financial_status_id;
                return /*#__PURE__*/ _jsx(Grstatus, {
                    statusID: statusID,
                    statusName: statusName,
                    finanStatusID: finanStatusID
                });
            }
        }
    ];
    var getAllGroupOfSupplierReducer = useAppSelector(function(state) {
        return state.getAllGroupOfSupplierReducer;
    });
    var getAllNewGrReducer = useAppSelector(function(state) {
        return state.getAllNewGrReducer;
    });
    var loadAllMsts = function() {
        dispatch(getAllGroupOfSupplier());
    };
    var getData = function(page, limit, searchText, groupSubID, mstNewStatusID) {
        var modifyMstNewStatusID = mstNewStatusID === "finanCancel" ? 6 : mstNewStatusID;
        var queryParams = _object_spread({
            mstNewStatusID: modifyMstNewStatusID,
            page: page,
            limit: limit,
            searchText: searchText,
            groupSubID: groupSubID
        }, mstNewStatusID === "finanCancel" && {
            financialStatusID: 5
        });
        dispatch(getAllNewGr({
            queryParams: queryParams,
            modalObj: modalObj,
            setModalObj: setModalObj
        }));
    };
    useEffect(function() {
        loadAllMsts();
        getData(1, pageModel.pageSize, "", "", "", "");
    }, []);
    useEffect(function() {
        setIsLoading(getAllGroupOfSupplierReducer.isFetching);
        if (getAllGroupOfSupplierReducer.data) {
            var options = mapMstToOptions(getAllGroupOfSupplierReducer.data.data);
            setOptionsGroupOfSuplier([
                defaultOption
            ].concat(_to_consumable_array(options)));
        }
    }, [
        getAllGroupOfSupplierReducer
    ]);
    useEffect(function() {
        setIsLoading(getAllNewGrReducer.isFetching);
        if (getAllNewGrReducer.data) {
            var result = getAllNewGrReducer.data.data.data;
            var meta = getAllNewGrReducer.data.data.meta;
            var grStatusCount = getAllNewGrReducer.data.data.grStatusCount;
            setData(result);
            setPageModel({
                page: meta.page,
                pageSize: meta.limit,
                total: meta.total
            });
            setGrStatusCount(function(prev) {
                return _object_spread({}, prev, grStatusCount);
            });
        // setTab(result);
        // const status0 = result.filter((item) => item.dim_mst_new_status_id === 1);
        // const status1 = result.filter((item) => item.dim_mst_new_status_id === 6);
        // const status2 = result.filter((item) => item.dim_mst_new_status_id === 7);
        // const status3 = result.filter((item) => item.dim_mst_new_status_id === 6 && item.dim_mst_financial_status_id === 5);
        // setTab0(status0);
        // setTab1(status1);
        // setTab2(status2);
        // setTab3(status3);
        }
    }, [
        getAllNewGrReducer
    ]);
    return /*#__PURE__*/ _jsxs("div", {
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "mb-3",
                children: [
                    /*#__PURE__*/ _jsxs(Button, {
                        type: "button",
                        className: "btn-category px-4 ".concat(btnempstatus == null ? " active" : "", " "),
                        onClick: function() {
                            setBtnempstatus(null);
                            setData(tab);
                        },
                        children: [
                            "ทั้งหมด",
                            " "
                        ]
                    }),
                    /*#__PURE__*/ _jsxs(Button, {
                        type: "button",
                        className: "btn-category px-4 ".concat(btnempstatus == 1 ? " active" : "", "  "),
                        onClick: function() {
                            setBtnempstatus(1);
                        },
                        children: [
                            "แบบร่าง (",
                            grStatusCount["1"],
                            ")"
                        ]
                    }),
                    /*#__PURE__*/ _jsxs(Button, {
                        type: "button",
                        className: "btn-category px-4 ".concat(btnempstatus == "finanCancel" ? " active" : "", "  "),
                        onClick: function() {
                            setBtnempstatus("finanCancel");
                        },
                        children: [
                            "รอแก้ไข (",
                            grStatusCount["finanCancel"],
                            ")"
                        ]
                    }),
                    /*#__PURE__*/ _jsx(Button, {
                        type: "button",
                        className: "btn-category px-4 ".concat(btnempstatus == 6 ? " active" : "", "  "),
                        onClick: function() {
                            setBtnempstatus(6);
                        },
                        children: "เสร็จสิ้น"
                    }),
                    /*#__PURE__*/ _jsxs(Button, {
                        type: "button",
                        className: "btn-category px-4 ".concat(btnempstatus == 7 ? " active" : "", "  "),
                        onClick: function() {
                            setBtnempstatus(7);
                        },
                        children: [
                            "ยกเลิก (",
                            grStatusCount["7"],
                            ")"
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "card card-st-2 ",
                children: /*#__PURE__*/ _jsxs("div", {
                    className: "card-body px-0 pt-4 pb-0",
                    children: [
                        /*#__PURE__*/ _jsxs("div", {
                            className: "d-flex align-items-center px-4 mb-3 flex-wrap",
                            children: [
                                /*#__PURE__*/ _jsx("div", {
                                    className: "me-4",
                                    style: {
                                        marginBottom: "12px"
                                    },
                                    children: /*#__PURE__*/ _jsx(DownloadExcel, {
                                        data: data,
                                        filename: "ใบสั่งซื้อ PO"
                                    })
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: "mb-2 me-auto",
                                    style: {
                                        width: "220px"
                                    },
                                    children: /*#__PURE__*/ _jsxs(Form.Group, {
                                        className: "form-st-3 sm pb-1",
                                        children: [
                                            /*#__PURE__*/ _jsx(Form.Label, {
                                                className: "mb-1",
                                                children: "กลุ่มผู้จัดจำหน่าย"
                                            }),
                                            /*#__PURE__*/ _jsx(Select, {
                                                as: "select",
                                                name: "",
                                                onChange: function(e) {
                                                    setSelectedGroupOfSuplierID(e.value);
                                                    setGroupOfSupplier(e);
                                                },
                                                className: "w-100 select-st-1",
                                                options: optionsGroupOfSuplier,
                                                placeholder: "",
                                                value: groupOfSupplier
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: "me-3 mb-2",
                                    children: /*#__PURE__*/ _jsx("input", {
                                        type: "text",
                                        className: "form-control form-st-4",
                                        placeholder: "ค้นหาเลขที่,ชื่อผู้จำหน่าย",
                                        onKeyUp: function(e) {
                                            return setFilterText(e.target.value);
                                        }
                                    })
                                }),
                                /*#__PURE__*/ _jsx(Button, {
                                    className: "btn btn btn-st-7 mb-2 px-4 bg-[#565DFF]",
                                    disabled: true,
                                    children: "สร้างใบรับสินค้า"
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsx(Box, {
                            sx: {
                                height: "782px",
                                width: "100%"
                            },
                            children: /*#__PURE__*/ _jsx(DataGrid, {
                                loading: getAllNewGrReducer.isFetching,
                                getRowId: function(row) {
                                    return row.id;
                                },
                                getRowHeight: function() {
                                    return "auto";
                                },
                                rows: data,
                                columns: columnsd,
                                pagination: true,
                                paginationMode: "server",
                                paginationModel: {
                                    page: pageModel.page - 1,
                                    pageSize: pageModel.pageSize
                                },
                                onPaginationModelChange: function(newPagination) {
                                    setPageModel(function(prev) {
                                        return _object_spread_props(_object_spread({}, prev), {
                                            page: newPagination.page + 1,
                                            pageSize: newPagination.pageSize
                                        });
                                    });
                                    getData(newPagination.page + 1, newPagination.pageSize, filterText || "", selectedGroupOfSuplierID, btnempstatus || "");
                                },
                                rowsPerPage: pageModel.page,
                                rowCount: pageModel.total,
                                pageSizeOptions: pageSizeOptions,
                                checkboxSelection: true,
                                disableRowSelectionOnClick: true,
                                slotProps: {
                                    pagination: {
                                        labelRowsPerPage: "จำนวนรายการต่อหน้า"
                                    }
                                },
                                sx: {
                                    fontFamily: "Sarabun",
                                    fontSize: "18px",
                                    ".MuiDataGrid-columnHeaderTitle": {
                                        fontFamily: "Sarabun",
                                        fontSize: "18px"
                                    }
                                }
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "py-4"
            })
        ]
    });
};
var gr_result = [
    {
        "id": 1,
        "doc_number": "GR-202304050005",
        "receipt_date": "02/11/2023",
        "doc_ref": "PO-2410000001-1",
        "consignee_name": "นาย วชิระ ภูวิท",
        "dimSupplierInformation": {
            "id": 4,
            "dim_mst_business_type_id": 2,
            "dim_mst_business_category_id": 1,
            "dim_group_of_supplier_id": 4,
            "dim_mst_prefix_id": null,
            "code": null,
            "credit_days": 0,
            "img_path": "media/dim-supplier-information/1723198186749-976816301.jpg",
            "tax_identification_number": "105600076669",
            "first_name": null,
            "last_name": null,
            "initials": "EGC",
            "dim_mst_company_prefix_id": 2,
            "company_name": "อีเจนซี่ เอเชีย",
            "company_branch_code": "00000",
            "company_branch_name": "สำนักงานใหญ่",
            "company_address": "354 ถ.พหลโยธิน",
            "company_sub_district": "เสนานิคม",
            "company_district": "จตุจักร",
            "company_province": "กรุงเทพมหานคร",
            "company_postal_code": "10900",
            "company_phone_number": "0888964222",
            "company_mobile_phone_number": "0888964222",
            "company_email": "a@mail.com",
            "company_website": "egencyasia.com",
            "doc_delivery_address": "354 ถ.พหลโยธิน",
            "doc_delivery_sub_district": "เสนานิคม",
            "doc_delivery_district": "จตุจักร",
            "doc_delivery_province": "กรุงเทพมหานคร",
            "doc_delivery_postal_code": "10900",
            "doc_delivery_phone_number": "0888964222",
            "doc_delivery_mobile_phone_number": "0888964222",
            "doc_delivery_email": "a@mail.com",
            "main_contact_first_name": null,
            "main_contact_last_name": null,
            "main_contact_nick_name": null,
            "main_contact_email": null,
            "main_contact_phone_number": null,
            "main_contact_mobile_phone_number": null,
            "main_contact_position": null,
            "alternate_contact_first_name": null,
            "alternate_contact_last_name": null,
            "alternate_contact_nick_name": null,
            "alternate_contact_email": null,
            "alternate_contact_phone_number": null,
            "alternate_contact_mobile_phone_number": null,
            "alternate_contact_position": null,
            "dim_mst_price_category_id": 2,
            "dim_mst_payment_term_id": null,
            "dim_mst_payment_method_id": null,
            "dim_mst_payment_type_id": 2,
            "is_credit_limit": null,
            "received_credit_limit": null,
            "line_token": null,
            "is_active": true,
            "created_by": 1,
            "created_at": "2024-08-09T10:09:47.000Z",
            "updated_at": "2024-08-29T04:12:09.000Z",
            "dimMstCompanyPrefix": {
                "id": 2,
                "name": "บริษัทจำกัด",
                "prefix": "บริษัท",
                "suffix": "จำกัด",
                "is_active": true,
                "created_at": "2024-08-09T12:55:54.000Z",
                "updated_at": "2024-08-16T01:28:13.000Z"
            },
            "dimGroupOfSupplier": {
                "id": 4,
                "code": "FZ01",
                "name": "สินค้าแช่เเข็ง",
                "desc": "สินค้าแช่เเข็ง",
                "is_active": true,
                "created_at": "2024-08-09T10:07:43.000Z",
                "updated_at": "2024-08-09T10:07:43.000Z",
                "deleted_at": null
            }
        },
        "dim_warehouse_id": 4,
        "dim_warehouse_name": "002-คลังสำนักงานใหญ่",
        "sum_item_quantity": 181,
        "item_quantity_receive": 0,
        "statusID": 0
    },
    {
        "id": 5,
        "doc_number": "GR-202304050006",
        "receipt_date": "02/11/2023",
        "doc_ref": "PO-2410000001-1",
        "consignee_name": "นาย วชิระ ภูวิท",
        "dimSupplierInformation": {
            "id": 4,
            "dim_mst_business_type_id": 2,
            "dim_mst_business_category_id": 1,
            "dim_group_of_supplier_id": 4,
            "dim_mst_prefix_id": null,
            "code": null,
            "credit_days": 0,
            "img_path": "media/dim-supplier-information/1723198186749-976816301.jpg",
            "tax_identification_number": "105600076669",
            "first_name": null,
            "last_name": null,
            "initials": "EGC",
            "dim_mst_company_prefix_id": 2,
            "company_name": "อีเจนซี่ เอเชีย",
            "company_branch_code": "00000",
            "company_branch_name": "สำนักงานใหญ่",
            "company_address": "354 ถ.พหลโยธิน",
            "company_sub_district": "เสนานิคม",
            "company_district": "จตุจักร",
            "company_province": "กรุงเทพมหานคร",
            "company_postal_code": "10900",
            "company_phone_number": "0888964222",
            "company_mobile_phone_number": "0888964222",
            "company_email": "a@mail.com",
            "company_website": "egencyasia.com",
            "doc_delivery_address": "354 ถ.พหลโยธิน",
            "doc_delivery_sub_district": "เสนานิคม",
            "doc_delivery_district": "จตุจักร",
            "doc_delivery_province": "กรุงเทพมหานคร",
            "doc_delivery_postal_code": "10900",
            "doc_delivery_phone_number": "0888964222",
            "doc_delivery_mobile_phone_number": "0888964222",
            "doc_delivery_email": "a@mail.com",
            "main_contact_first_name": null,
            "main_contact_last_name": null,
            "main_contact_nick_name": null,
            "main_contact_email": null,
            "main_contact_phone_number": null,
            "main_contact_mobile_phone_number": null,
            "main_contact_position": null,
            "alternate_contact_first_name": null,
            "alternate_contact_last_name": null,
            "alternate_contact_nick_name": null,
            "alternate_contact_email": null,
            "alternate_contact_phone_number": null,
            "alternate_contact_mobile_phone_number": null,
            "alternate_contact_position": null,
            "dim_mst_price_category_id": 2,
            "dim_mst_payment_term_id": null,
            "dim_mst_payment_method_id": null,
            "dim_mst_payment_type_id": 2,
            "is_credit_limit": null,
            "received_credit_limit": null,
            "line_token": null,
            "is_active": true,
            "created_by": 1,
            "created_at": "2024-08-09T10:09:47.000Z",
            "updated_at": "2024-08-29T04:12:09.000Z",
            "dimMstCompanyPrefix": {
                "id": 2,
                "name": "บริษัทจำกัด",
                "prefix": "บริษัท",
                "suffix": "จำกัด",
                "is_active": true,
                "created_at": "2024-08-09T12:55:54.000Z",
                "updated_at": "2024-08-16T01:28:13.000Z"
            },
            "dimGroupOfSupplier": {
                "id": 4,
                "code": "FZ01",
                "name": "สินค้าแช่เเข็ง",
                "desc": "สินค้าแช่เเข็ง",
                "is_active": true,
                "created_at": "2024-08-09T10:07:43.000Z",
                "updated_at": "2024-08-09T10:07:43.000Z",
                "deleted_at": null
            }
        },
        "dim_warehouse_id": 4,
        "dim_warehouse_name": "002-คลังสำนักงานใหญ่",
        "sum_item_quantity": 181,
        "item_quantity_receive": 0,
        "statusID": 1
    },
    {
        "id": 2,
        "doc_number": "GR-202304050007",
        "receipt_date": "02/11/2023",
        "doc_ref": "PO-2410000001-1",
        "consignee_name": "นาย วชิระ ภูวิท",
        "dimSupplierInformation": {
            "id": 4,
            "dim_mst_business_type_id": 2,
            "dim_mst_business_category_id": 1,
            "dim_group_of_supplier_id": 4,
            "dim_mst_prefix_id": null,
            "code": null,
            "credit_days": 0,
            "img_path": "media/dim-supplier-information/1723198186749-976816301.jpg",
            "tax_identification_number": "105600076669",
            "first_name": null,
            "last_name": null,
            "initials": "EGC",
            "dim_mst_company_prefix_id": 2,
            "company_name": "อีเจนซี่ เอเชีย",
            "company_branch_code": "00000",
            "company_branch_name": "สำนักงานใหญ่",
            "company_address": "354 ถ.พหลโยธิน",
            "company_sub_district": "เสนานิคม",
            "company_district": "จตุจักร",
            "company_province": "กรุงเทพมหานคร",
            "company_postal_code": "10900",
            "company_phone_number": "0888964222",
            "company_mobile_phone_number": "0888964222",
            "company_email": "a@mail.com",
            "company_website": "egencyasia.com",
            "doc_delivery_address": "354 ถ.พหลโยธิน",
            "doc_delivery_sub_district": "เสนานิคม",
            "doc_delivery_district": "จตุจักร",
            "doc_delivery_province": "กรุงเทพมหานคร",
            "doc_delivery_postal_code": "10900",
            "doc_delivery_phone_number": "0888964222",
            "doc_delivery_mobile_phone_number": "0888964222",
            "doc_delivery_email": "a@mail.com",
            "main_contact_first_name": null,
            "main_contact_last_name": null,
            "main_contact_nick_name": null,
            "main_contact_email": null,
            "main_contact_phone_number": null,
            "main_contact_mobile_phone_number": null,
            "main_contact_position": null,
            "alternate_contact_first_name": null,
            "alternate_contact_last_name": null,
            "alternate_contact_nick_name": null,
            "alternate_contact_email": null,
            "alternate_contact_phone_number": null,
            "alternate_contact_mobile_phone_number": null,
            "alternate_contact_position": null,
            "dim_mst_price_category_id": 2,
            "dim_mst_payment_term_id": null,
            "dim_mst_payment_method_id": null,
            "dim_mst_payment_type_id": 2,
            "is_credit_limit": null,
            "received_credit_limit": null,
            "line_token": null,
            "is_active": true,
            "created_by": 1,
            "created_at": "2024-08-09T10:09:47.000Z",
            "updated_at": "2024-08-29T04:12:09.000Z",
            "dimMstCompanyPrefix": {
                "id": 2,
                "name": "บริษัทจำกัด",
                "prefix": "บริษัท",
                "suffix": "จำกัด",
                "is_active": true,
                "created_at": "2024-08-09T12:55:54.000Z",
                "updated_at": "2024-08-16T01:28:13.000Z"
            },
            "dimGroupOfSupplier": {
                "id": 4,
                "code": "FZ01",
                "name": "สินค้าแช่เเข็ง",
                "desc": "สินค้าแช่เเข็ง",
                "is_active": true,
                "created_at": "2024-08-09T10:07:43.000Z",
                "updated_at": "2024-08-09T10:07:43.000Z",
                "deleted_at": null
            }
        },
        "dim_warehouse_id": 4,
        "dim_warehouse_name": "002-คลังสำนักงานใหญ่",
        "sum_item_quantity": 181,
        "item_quantity_receive": 0,
        "statusID": 2
    }
];
